// SPDX-License-Identifier: AGPL-3.0-or-later

import {LimitResolver} from '@app/features/app/utils/LimitResolverAdapter';

// Off: no ranked switch, no leaderboard entry points and no privacy setting (the server refuses the routes too).
export function isTableGameRankedEnabled(): boolean {
	return LimitResolver.resolve({key: 'feature_table_game_ranked', fallback: 0}) > 0;
}
